
import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/rem'
import store from './store/store.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'// swiper
import 'swiper/dist/css/swiper.css'
import './assets/common/index.scss'
import './assets/iconfont/iconfont.css'
// import './utils/sole'// sole调试 
import '@/public/vuxPublicCom.js' // vux 全局组件
import vuxEncapue from '@/public/vuxEncapue.js' // vux 部分组件注册到vue全局
import VueLazyload from 'vue-lazyload'

import { md5Obj } from './utils/encrypt'
import publicComs from './public/publicComs' // 全局公用组件

Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(publicComs)
Vue.use(vuxEncapue)
Vue.use(VueLazyload)
Vue.prototype.$md5 = md5Obj

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js